module.exports = __webpack_public_path__ + "static/media/TransactionSubmitted.7e734642.svg";